(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zonoko-carrusel-tarjetas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zonoko-card-carousel')) {
    class ZonokoCardCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.zonoko-card-carousel__viewport');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.status = this.querySelector('[data-status]');

        if (!this.viewport || !this.slides.length) return;

        this.activeIndex = this.clampIndex(Number(this.dataset.initialSlide) || 0);
        this.dragging = false;
        this.moved = false;
        this.scrollFrame = null;

        this.onPointerDown = this.handlePointerDown.bind(this);
        this.onPointerMove = this.handlePointerMove.bind(this);
        this.onPointerUp = this.handlePointerUp.bind(this);
        this.onScroll = this.handleScroll.bind(this);
        this.onKeyDown = this.handleKeyDown.bind(this);
        this.onDotClick = this.handleDotClick.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        this.onResize = this.handleResize.bind(this);

        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        this.viewport.addEventListener('pointermove', this.onPointerMove);
        this.viewport.addEventListener('pointerup', this.onPointerUp);
        this.viewport.addEventListener('pointercancel', this.onPointerUp);
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.onKeyDown);
        this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        window.addEventListener('resize', this.onResize, { passive: true });

        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.goTo(this.activeIndex, false));
        });
      }

      disconnectedCallback() {
        if (!this.viewport) return;
        this.viewport.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport.removeEventListener('pointermove', this.onPointerMove);
        this.viewport.removeEventListener('pointerup', this.onPointerUp);
        this.viewport.removeEventListener('pointercancel', this.onPointerUp);
        this.viewport.removeEventListener('scroll', this.onScroll);
        this.viewport.removeEventListener('keydown', this.onKeyDown);
        this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.removeEventListener('resize', this.onResize);
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      clampIndex(index) {
        return Math.max(0, Math.min(index, this.slides.length - 1));
      }

      slideLeft(index) {
        const slide = this.slides[this.clampIndex(index)];
        return slide.offsetLeft - (this.viewport.clientWidth - slide.offsetWidth) / 2;
      }

      goTo(index, smooth = true) {
        const nextIndex = this.clampIndex(index);
        this.viewport.scrollTo({
          left: this.slideLeft(nextIndex),
          behavior: smooth ? 'smooth' : 'auto'
        });
        this.setActive(nextIndex);
      }

      setActive(index) {
        const nextIndex = this.clampIndex(index);
        if (nextIndex === this.activeIndex && this.slides[nextIndex].classList.contains('is-active')) return;

        this.activeIndex = nextIndex;
        this.slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === nextIndex);
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === nextIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (this.status) {
          this.status.textContent = `Tarjeta ${nextIndex + 1} de ${this.slides.length}`;
        }
      }

      closestIndex() {
        const viewportCenter = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
        let closest = 0;
        let distance = Infinity;

        this.slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const nextDistance = Math.abs(viewportCenter - slideCenter);
          if (nextDistance < distance) {
            distance = nextDistance;
            closest = index;
          }
        });

        return closest;
      }

      handlePointerDown(event) {
        if (event.pointerType === 'touch') return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.dragging = true;
        this.moved = false;
        this.startX = event.clientX;
        this.startScrollLeft = this.viewport.scrollLeft;
        this.viewport.classList.add('is-dragging');
        this.viewport.setPointerCapture(event.pointerId);
      }

      handlePointerMove(event) {
        if (!this.dragging) return;
        const distance = event.clientX - this.startX;
        if (Math.abs(distance) > 4) this.moved = true;
        this.viewport.scrollLeft = this.startScrollLeft - distance;
      }

      handlePointerUp(event) {
        if (!this.dragging) return;
        this.dragging = false;
        this.viewport.classList.remove('is-dragging');
        if (this.viewport.hasPointerCapture(event.pointerId)) {
          this.viewport.releasePointerCapture(event.pointerId);
        }
        this.goTo(this.closestIndex(), true);
      }

      handleScroll() {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          this.setActive(this.closestIndex());
        });
      }

      handleKeyDown(event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.activeIndex + 1, true);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.activeIndex - 1, true);
        }
        if (event.key === 'Home') {
          event.preventDefault();
          this.goTo(0, true);
        }
        if (event.key === 'End') {
          event.preventDefault();
          this.goTo(this.slides.length - 1, true);
        }
      }

      handleDotClick(event) {
        this.goTo(Number(event.currentTarget.dataset.index), true);
      }

      handleBlockSelect(event) {
        const slide = event.target.closest('[data-slide]');
        if (!slide || !this.contains(slide)) return;
        this.goTo(Number(slide.dataset.index), true);
      }

      handleResize() {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.goTo(this.activeIndex, false), 120);
      }
    }

    customElements.define('zonoko-card-carousel', ZonokoCardCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
